import React from 'react';
import '../Markets.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Helper to determine which pages to show
  const getVisiblePages = () => {
    const delta = 1; // Number of pages to show before and after current
    let range = [];
    
    // Always include first page
    range.push(1);
    
    // Calculate start and end of range
    const rangeStart = Math.max(2, currentPage - delta);
    const rangeEnd = Math.min(totalPages - 1, currentPage + delta);
    
    // Add ellipsis if needed before range
    if (rangeStart > 2) {
      range.push('...');
    }
    
    // Add all pages in the middle range
    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }
    
    // Add ellipsis if needed after range
    if (rangeEnd < totalPages - 1) {
      range.push('...');
    }
    
    // Always include last page if not first
    if (totalPages > 1) {
      range.push(totalPages);
    }
    
    return range;
  };

  return (
    <div className="pagination-container">
      <button 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-button"
      >
        &lt;
      </button>
      
      {getVisiblePages().map((page, index) => (
        page === '...' ? (
          <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`pagination-button ${currentPage === page ? 'active' : ''}`}
          >
            {page}
          </button>
        )
      ))}
      
      <button 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="pagination-button"
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination; 